<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: 0,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('table_label_fabricInformation') || '面料信息'
            }}</span>
          </div>
        </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displayFabricName="{ row }">
        <TableLabel :value="row.fabricName" />
        <TableLabel :value="row.fabricNameEn" />
        <TableLabel label="NO" :value="row.fabricNo" />
      </template>
      <template v-slot:fabricCardStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.fabricCardStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.v_fabricCardStatus }}
        </el-tag>
      </template>

      <template v-slot:displayWid="{ row }">
        <TableLabel label="门幅" :value="`${row.wid || 0} ${row.widUnit}`" />
        <TableLabel
          label="克重"
          :value="`${row.fabricWeight || 0} ${row.fabricWeightUnit}`"
        />
      </template>
      <template v-slot:displayFabricContent="{ row }">
        <TableLabel :value="row.fabricContent" />
        <TableLabel :value="row.fabricContentEn" />
      </template>

      <template v-slot:displayPrice="{ row }">
        <span>{{ row.unitPrice }} 元/ {{ row.v_fabricUnit }}</span>
      </template>

      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="allow('D')"
        >
          <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight],
  components: { TableLabel },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    isSingle: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        zoom: true,
        custom: true,
      },
      selectList: [],
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 70,
          fixed: 'right',
          visible: !this.isSingle,
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.table_label_image') || '图片',
          align: 'center',
          fixed: 'left',
          slots: { default: 'defaultImageUrl' },
        },
        {
          title: this.$l('table_label_displayFabricName') || '面料名称',
          field: 'displayFabricName',
          minWidth: 300,
          align: 'left',
          showHeaderOverflow: true,
          slots: { default: 'displayFabricName' },
        },

        {
          title: this.$l('table_lable_fabricCardBarcode') || '面料条码',
          field: 'fabricCardBarcode',
          minWidth: 150,
          align: 'left',
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_lable_warehouse_location') || '库位',
          field: 'locationNo',
          minWidth: 150,
          align: 'left',
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_displayWid') || '颜色克重',
          field: 'displayWid',
          minWidth: 150,
          align: 'left',
          showHeaderOverflow: true,
          slots: { default: 'displayWid' },
        },
        {
          title: this.$l('table_label_displayFabricContent') || '面料成分',
          field: 'displayFabricContent',
          minWidth: 180,
          align: 'left',
          showHeaderOverflow: true,
          slots: { default: 'displayFabricContent' },
        },
        {
          title: this.$l('table_label_fabricStatus') || '状态',
          field: 'fabricCardStatus',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          slots: { default: 'fabricCardStatus' },
        },
        {
          title: this.$l('table_label_displayCreate') || '创建人',
          field: 'displayCreate',
          minWidth: 170,
          align: 'left',
          showHeaderOverflow: true,
          slots: { default: 'displayCreate' },
        },
        {
          title: this.$l('table_label_displayModify') || '修改人',
          field: 'displayModify',
          minWidth: 170,
          align: 'left',
          showHeaderOverflow: true,
          slots: { default: 'displayModify' },
        },
      ],
    }
  },
  methods: {
    delRow(row) {
      const { tableData = [] } = this.$refs.table.getTableData()
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i]._XID == row._XID) {
          this.$emit('delRow', i)
          return
        }
      }
    },
  },
}
</script>
